module.exports = __webpack_public_path__ + "static/media/submetrics-increment-arrow.62d997f6.svg";